import { render, staticRenderFns } from "./SeamansWifeInsights.vue?vue&type=template&id=d21c23a4&scoped=true"
import script from "./SeamansWifeInsights.vue?vue&type=script&lang=js"
export * from "./SeamansWifeInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21c23a4",
  null
  
)

export default component.exports